export default __webpack_public_path__ + "static/media/campreviewer.a844a9c7.jpg";